import get from 'lodash/get';
import {
  getDocumentFields,
  getFileUrl,
  getOptimizedContentfulImage,
} from 'utils/helper';

export const useCaseStudiesIntro = ({
  type,
  introSection,
  data,
}) => {
  const {
    title,
    description,
    formattedDescription,
    images,
    contentModules,
  } = data;

  const imageUrl = getOptimizedContentfulImage(
    getFileUrl(images[0]),
    { fm: 'png' },
  );

  const badgeData = getDocumentFields(contentModules[0], ['description', 'title']);
  const { images: logoImages } = getDocumentFields(contentModules[1], ['images']);

  const logoImagesUrls = logoImages.map((image) => getOptimizedContentfulImage(
    getFileUrl(image),
    { fm: 'png', width: 200, height: 200 },
  ));

  return {
    type,
    introSection,
    title,
    description,
    formattedDescription,
    imageUrl,
    badgeData,
    logoImagesUrls,
  };
};
